import { Container, Grid } from "@mui/material";
import React from "react";
import {   SectionWrapper } from "../../../Styles/style";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import AccordianMain from "../../../Components/Accordian/Accordian";
import TwitterIcon from '@mui/icons-material/Twitter';
const ManImg = styled.img`
width: 100%;
height: auto;
max-width: 500px;
`
const GridWrapper = styled(Grid)`
display: flex;
align-items: center;
`
const JOiningLinks = styled.img`
  width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "450px")};
  @media screen and (max-width:599px){
   /* max-width: ${(props) => (props.mw ? props.mw : "140PX")}; */

 }
`
const P = styled.p`
  font-weight: ${(props) => (props.fw ? props.fw : "")};
  font-family: "consol";
  font-size: ${(props) => (props.fs ? props.fs : "18px")};
  color: #000;
  background-color: ${(props) => (props.bgcolor ? props.bgcolor : "")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  margin: ${(props) => (props.m ? props.m : "20px 0")};
  padding: ${(props) => (props.p ? props.p : "")};
  display: ${(props) => (props.display ? props.display : "")};
  justify-content: ${(props) => (props.jc ? props.jc : "")};
  @media (max-width: 600px) {
    font-size: ${(props) => (props.fs600px ? props.fs600px : "")};
    max-width: 100%;
  }
  @media (max-width: 1440px) and (max-height: 620px) {
    padding-top: ${(props) => (props.pt630 ? props.pt630 : "0px")};
  }
`;
const SectionHeading = styled.h1`
font-family: "digit";
text-transform:uppercase;
  font-size: ${(props) => (props.fs ? props.fs : "150px")};
  color: #000;
  padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  /* line-height: ${(props) => (props.lh ? props.lh : "50px")}; */
  max-width: ${(props) => (props.mw ? props.mw : "100%")};
  text-align: ${(props) => (props.align ? props.align : "center")};
  @media screen and (max-width: 1199px) {
    font-size: 100px;
  }
  @media (max-width: 599px) {
    font-size: ${(props) => (props.fs599 ? props.fs599 : "70px")};
    padding: ${(props) => (props.p599 ? props.p599 : "")};
  }
  @media (max-width: 399px) {
    font-size: ${(props) => (props.fs399 ? props.fs399 : "55px")};
    padding: ${(props) => (props.p399 ? props.p399 : "")};
  }
`;
const Section8_Team = () => {
  const theme = useTheme()
  return (
    <SectionWrapper  p="4rem 0" id="FAQ">
      <Container maxWidth="xl"  data-aos="fade-zoom-in" data-aos-easing="ease-in" data-aos-delay="500" data-aos-duration="500" data-aos-offset="0">
      <SectionHeading fs="70px" p="20px 0" m="0" align="center" data-aos="flip-up"
              data-aos-easing="ease-in"
              data-aos-delay="400"
              data-aos-duration="500"
              data-aos-offset="0"  fs599="40PX" fs399="40PX">
             Disclaimer:
            </SectionHeading>
        <GridWrapper item xs={12} md={6}>
            <P align="center"
                p="0 0 0 0"
                m="0"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-duration="600"
                data-aos-offset="0"
              >
             Investing in cryptocurrencies involves risks, including the potential loss of your investment.
The value of cryptocurrencies can be highly volatile, and market conditions can change
rapidly. We recommend conducting thorough research and consulting with financial professionals
before making any investment decisions. However, with risk comes opportunity, and by embracing
the potential of cryptocurrencies like Shib on the Pulse Network, you can seize exciting
possibilities and embrace the future of decentralized finance.
               </P>
      </GridWrapper>
            
       {/* <AccordianMain/> */}
      </Container>
    </SectionWrapper>
  )
};

export default Section8_Team;
